const CONTACT_API = process.env.REACT_APP_CONTACT_API_URL || '/api/contact';

export async function submitContactForm({ email, subject, message, turnstileToken, honey = '' }) {
  const response = await fetch(CONTACT_API, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      email,
      subject,
      message,
      turnstileToken,
      _honey: honey,
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.success === false) {
    throw new Error(data.message || 'Unable to send your message. Please try again.');
  }

  return data;
}
